module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "el",
      "data-toggle": "popover",
      "title": _vm.title,
      "data-content": _vm.content
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-88c3ba94!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BootstrapPopover.vue
// module id = 510
// module chunks = 2